/**
 * @file popupscene.js
 * @desc This module contains UI Scene class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

var Scene = require('scene').Scene;
var Animation = require('animation').Animation;

var screenConfig = require('cfg/screen-config');

(/** @lends <global> */function (global) {
    'use strict';
    
    /**
     * Constructs UIScene object.
     * @class
     * @constructor
     * @param {Object} controller The delegate of double game scene - handles double game events
     * @param {Object} model Data source
     * @param {Object} config Scene configuration
     * @name UIScene
     * @classdesc This is a complete fully configured GUI component.
     * @extends {Scene}
     * @requires Scene
     * */
    var PopupScene = function(config) {
        Scene.call(this);
        
        // No connection banner
        this.noConnectionBanner = new PIXI.Sprite(PIXI.utils.TextureCache["no_connection_table.png"]);
        this.noConnectionBanner.anchor.set(0.5, 0.5);
        this.noConnectionBanner.position.set(screenConfig.resolution.width / 2, screenConfig.resolution.height / 2);
        this.addChild(this.noConnectionBanner);
        
        this.noConnectionBanner.visible = false;
        
        // var indicatorAnimations = [];
        
        // for (var i = 0; i <= 10; ++i) {
        //     indicatorAnimations.push(PIXI.utils.TextureCache["no_connection_indicator_%03d.png".$(i)]);
        // }
        //
        // this.noConnectionIndicator = new PIXI.extras.MovieClip(indicatorAnimations);
        this.noConnectionIndicator = Animation.byFrameName("no_connection_indicator_%03d.png", 10);
        this.noConnectionBanner.addChild(this.noConnectionIndicator);
        this.noConnectionIndicator.animationSpeed = 0.1;
        this.noConnectionIndicator.position.set(-128,-128);
        // No connection banner
        
        
        this.connectionFailedBanner = new PIXI.Sprite(PIXI.utils.TextureCache["res/common/connection_failed.png"]);
        this.connectionFailedBanner.anchor.set(0.5, 0.5);
        this.connectionFailedBanner.position.set(screenConfig.resolution.width / 2, screenConfig.resolution.height / 2);
        this.addChild(this.connectionFailedBanner);
        this.connectionFailedBanner.visible = false;
    
    
        this.processWaitIndicator = Animation.byFrameName("load_process_indicator_%03d.png", 12);
        this.processWaitIndicator.position.set(config.resolution.width / 2, config.resolution.height / 2);
        this.processWaitIndicator.anchor.set(0.5, 0.5);
        this.processWaitIndicator.loop = true;
        this.processWaitIndicator.animationSpeed = 0.2;
        this.addChild(this.processWaitIndicator);
        this.processWaitIndicator.visible = false;
        this.processWaitIndicator.gotoAndPlay(0);

    };
    
    PopupScene.prototype = Object.create(Scene.prototype);
    
    PopupScene.prototype.constructor = PopupScene;
    
    
    /**
     * Shows banner 'FAILED CONNECTION'
     * @memberOf SceneManager
     * */
    PopupScene.prototype.showFatalErrorBanner = function () {
        this.connectionFailedBanner.visible = true;
        
        this.hideProcessIndicator();
    };

    /**
     * Hide banners 'FAILED CONNECTION' and 'NO CONNECTION'
     * @memberOf SceneManager
     * */
    PopupScene.prototype.hideErrorBanners = function () {

        this.connectionFailedBanner.visible = false;
        this.noConnectionBanner.visible = false;

        this.noConnectionIndicator.gotoAndPlay(0);
    };
    
    /**
     * Shows banner 'NO CONNECTION'
     * @memberOf SceneManager
     * */
    PopupScene.prototype.showNoConnectionBanner = function () {
        this.noConnectionBanner.visible = true;
        this.noConnectionIndicator.gotoAndPlay(0);
        
        this.hideProcessIndicator();
    };
    
    /**
     * Hides banner 'NO CONNECTION'
     * @memberOf SceneManager
     * */
    PopupScene.prototype.hideNoConnectionBanner = function () {
        this.noConnectionBanner.visible = false;
        this.noConnectionIndicator.gotoAndStop(0);
    };
    
    PopupScene.prototype.showProcessIndicator = function () {
        this.processWaitIndicator.visible = true;
    };
    
    PopupScene.prototype.hideProcessIndicator = function () {
        this.processWaitIndicator.visible = false;
    };
    
    global.PopupScene = PopupScene;
}(typeof module === 'object' && module.exports || this));



//////////////////
// WEBPACK FOOTER
// ./src/library/popupscene.js
// module id = 97
// module chunks = 0